import React from "react";

const SelectableMenu = ({ options, value, setValue, className }) => {
  return (
    <div className={`d-flex align-items-center mt-2 ${className}`}>
      {options.map((option) => (
        <div
          key={option.value}
          className={
            option.value === value
              ? "text-primary text-decoration-underline mr-2"
              : "text-silver mr-2 cursor-pointer"
          }
          onClick={() => setValue(option.value)}
        >
          {option.label}
        </div>
      ))}
    </div>
  );
};

export default SelectableMenu;